
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes05On as ObiDiodes05OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-05-on.js';
 
 
 

 
 export const ObiDiodes05On = createComponent({
   react: React,
   tagName: 'obi-diodes-05-on',
   elementClass: ObiDiodes05OnElement,
   events: {
     
   }
  });
 
 